/*
 * Copyright (c) 2022-2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  store(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  retrieve(key: string): string | null {
    return localStorage.getItem(key);
  }
}
